// IndexedDB queue for offline draft reports awaiting submission.
const DB_NAME = "reencuentro_offline";
const STORE = "pending_reports";

function openDB() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, 1);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains(STORE)) db.createObjectStore(STORE, { keyPath: "id" });
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

function notify() {
  window.dispatchEvent(new Event("offline-queue-changed"));
}

export async function addPending(item) {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE, "readwrite");
    tx.objectStore(STORE).put(item);
    tx.oncomplete = () => { notify(); resolve(item); };
    tx.onerror = () => reject(tx.error);
  });
}

export async function getPending() {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE, "readonly");
    const req = tx.objectStore(STORE).getAll();
    req.onsuccess = () => resolve((req.result || []).sort((a, b) => (a.created_at < b.created_at ? 1 : -1)));
    req.onerror = () => reject(req.error);
  });
}

export async function updatePending(item) {
  return addPending(item);
}

export async function removePending(id) {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE, "readwrite");
    tx.objectStore(STORE).delete(id);
    tx.oncomplete = () => { notify(); resolve(); };
    tx.onerror = () => reject(tx.error);
  });
}

export async function countPending() {
  try { return (await getPending()).length; } catch { return 0; }
}
